

export class Invoice {
    InvoiceCode!: string;
    InvoiceDate!: Date;
    InvoiceAmount!: number;
    InvoicePurchaseOrder!: string;
    tempInvoicePurchaseOrder!: string;
    InvoiceExcelFile!: string;
    InvoiceConfiguration!: string;
    InvoiceELE!:string;
    ContactCode!:string;
    ClientName!:string;
    Reseau!:string;
    Comment!:string;
    Pattern!:string;
    Placeholder!:string;


    
    static mapFromJSON(json: any) {
        const p = new Invoice();
        p.InvoiceCode = json['invoiceCode'];
        p.InvoiceDate = new Date(json['invoiceDate']);;
        p.InvoiceAmount = json['invoiceAmount'];
        p.InvoicePurchaseOrder = json['invoicePurchaseOrder'];
        p.InvoiceExcelFile = json['invoiceExcelFile'];
        p.InvoiceConfiguration = json['invoiceConfiguration'];
        p.InvoiceELE = json['invoiceELE'];
        p.ContactCode = json['contactCode'];
        p.ClientName = json['clientName'];
        p.Reseau=json["reseau"];
        p.Comment=json["comment"];
        p.Pattern=json["pattern"];
        p.Placeholder=json["placeholder"];
        return p;
    }
}
